import script from "./WorkspaceLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./WorkspaceLayout.vue?vue&type=script&lang=ts&setup=true"

import "./WorkspaceLayout.vue?vue&type=style&index=0&id=78ae050b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78ae050b"]])

export default __exports__